export const SERVICE_STATE = {
    OK: 1,
    MAINTENANCE: 2,
    ERROR: 3
};

export const BAD_GATEWAY = 502;
export const SERVICE_UNAVAILABLE = 503;
export const GATEWAY_TIMEOUT = 504;
export const FORBIDDEN = 403;
export const OK = 200;

export const BEEHERO_IO_URL = 'https://beehero.io';
export const ADMIN_API = '/admin';
export const DEMO_ACCOUNT_URL = `${process.env.REACT_APP_BEEHERO_GROWERS}?is_public_user=true`;
export const AXIOS_NETWORK_ERROR_MESSAGE = 'Network Error';
export const emailKey = 'email';
export const emailLabelText = 'Email';
export const enterEmailText = 'Enter email';
export const nameKey = 'name';
export const groupNameKey = 'group_name';
export const phoneKey = 'phone_number';
export const roleKey = 'role';
export const passwordKey = 'password';
export const passwordConfirmationKey = 'password_confirmation';
export const enterPasswordText = 'Enter password';
export const passwordLabelText = 'Password';
export const emailIsRequiredText = 'Email is required';
export const passwordIsRequiredText = 'Password is required';
export const nameIsRequiredText = 'Name is required';
export const roleIsRequiredText = 'Role is required';
export const invalidEmailText = 'Invalid email address';
export const invalidPhoneText = 'Invalid phone number';
export const allAppsText = 'AllApps';
export const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
export const loginToYourAccountText = 'Login to your account';
